<script setup>
import { ref } from 'vue'
import DonationButton from '../components/DonationButton.vue'

const dialog = ref(false)
const opened = ref(false)

function onOpened() {
    opened.value = true
}

function open() {
    opened.value = false
    dialog.value = true
}
</script>

<template>
<div id="menu" @click="open">
    <v-icon icon="mdi-heart" color="white"></v-icon>
    <v-tooltip activator="parent" location="right">Donate</v-tooltip>
</div>

<v-dialog transition="dialog-bottom-transition" :width="500" v-model="dialog" scrollable>
    <v-card class="donate-card">

        <!-- Toolbar -->
        <v-toolbar dark class="donate-toolbar">
            <v-icon class="mr-2">mdi-heart</v-icon>
            <div class="toolbar-content">
                <v-toolbar-title class="toolbar-main-title">Support NIGHTRIDERZ</v-toolbar-title>
                <div class="toolbar-subtitle">100% goes to server infrastructure</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false" variant="text">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card-text class="donate-body">

            <!-- Etat normal -->
            <div v-if="!opened">

                <!-- Coûts serveur -->
                <div class="costs-banner">
                    <div class="cost-pill">
                        <v-icon size="small" color="#ef9a9a">mdi-server</v-icon>
                        <span>Server <b>€50</b>/mo</span>
                    </div>
                    <div class="cost-pill">
                        <v-icon size="small" color="#ef9a9a">mdi-email</v-icon>
                        <span>Emails <b>€16</b>/mo</span>
                    </div>
                    <div class="cost-pill">
                        <v-icon size="small" color="#ef9a9a">mdi-test-tube</v-icon>
                        <span>Test server <b>€15</b>/mo</span>
                    </div>
                    <div class="cost-pill">
                        <v-icon size="small" color="#ef9a9a">mdi-cloud</v-icon>
                        <span>CDN <b>€1</b>/mo</span>
                    </div>
                </div>

                <div class="total-bar">
                    <span class="total-label">Monthly total</span>
                    <span class="total-value">€82 / month</span>
                </div>

                <v-divider class="my-4" />

                <p class="donate-desc">
                    No perks, no rewards — just your support keeping the server alive for everyone.
                </p>

                <!-- Bouton PayPal donation -->
                <DonationButton @opened="onOpened" />
            </div>

            <!-- Etat après ouverture de PayPal -->
            <div v-else class="donate-success">
                <div class="success-icon-wrap">
                    <v-icon size="64" color="#ef5350">mdi-heart</v-icon>
                </div>
                <h2>Thank you!</h2>
                <p>Your PayPal window is open. Complete the donation there — it will be recorded automatically once confirmed.</p>
                <v-btn variant="text" size="small" class="mt-2" @click="opened = false">← Make another donation</v-btn>
            </div>

        </v-card-text>
    </v-card>
</v-dialog>
</template>

<style scoped>
/* ---- Bouton navbar ---- */
#menu {
    font-weight: bold;
    color: white;
    text-decoration: none;
    border-radius: 6px;
    margin-bottom: 10px;
    height: 40px;
    width: 40px;
    background: transparent;
    transition: all 0.15s ease-in-out;
    display: flex;
    align-items: center;
    cursor: pointer;
}

#menu i {
    margin: 0 7px;
}

#menu:hover {
    background: var(--quaternary-color);
}

/* ---- Dialog ---- */
.donate-card {
    background: var(--primary-color, #1e1e2e);
}

.donate-toolbar {
    background: linear-gradient(90deg, #b71c1c 0%, #e53935 100%) !important;
    padding: 8px 16px !important;
}

.toolbar-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
}

.toolbar-main-title {
    font-size: 1.25rem !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
}

.toolbar-subtitle {
    font-size: 0.82rem;
    color: rgba(255,255,255,0.75);
    line-height: 1;
}

/* ---- Body ---- */
.donate-body {
    padding: 1.5rem 1.5rem 1.8rem;
}

/* ---- Coûts ---- */
.costs-banner {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-bottom: 12px;
}

.cost-pill {
    background: rgba(239, 83, 80, 0.08);
    border: 1px solid rgba(239, 83, 80, 0.2);
    border-radius: 10px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.88rem;
    color: #ccc;
}

.cost-pill b {
    color: #fff;
}

.total-bar {
    background: rgba(239, 83, 80, 0.15);
    border: 1px solid rgba(239, 83, 80, 0.3);
    border-radius: 10px;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.total-label {
    color: #ef9a9a;
    font-size: 0.9rem;
    font-weight: 500;
}

.total-value {
    color: #fff;
    font-size: 1.1rem;
    font-weight: 700;
}

.donate-desc {
    text-align: center;
    color: #aaa;
    font-size: 0.88rem;
    margin-bottom: 1.2rem;
    line-height: 1.5;
}

/* ---- Succès ---- */
.donate-success {
    text-align: center;
    padding: 1.5rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.success-icon-wrap {
    background: rgba(239, 83, 80, 0.1);
    border-radius: 50%;
    width: 96px;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.donate-success h2 {
    font-size: 1.6rem;
    color: #ef9a9a;
    margin: 0;
}

.donate-success p {
    color: #aaa;
    font-size: 0.9rem;
    max-width: 340px;
    line-height: 1.5;
}
</style>
